import styled from "styled-components";

/**
 * Wrapper principal do carrossel (Mobile)
 */
export const CarouselWrapperMobile = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
  padding: ${({ theme }) => theme.spacing(2)} 0;
  gap: ${({ theme }) => theme.spacing(2)};
`;

/**
 * Wrapper dos cartões do carrossel (Mobile)
 */
export const CardsWrapperMobile = styled.div`
  display: flex;
  overflow: hidden;
  width: 100%;
`;

/**
 * Track dos itens do carrossel (Mobile)
 */
export const TrackMobile = styled.div.withConfig({
  shouldForwardProp: (prop) => !["offset", "isDragging"].includes(prop),
})<{ offset: number; isDragging: boolean }>`
  transform: ${({ offset }) => `translateX(-${offset}px)`};
  transition: ${({ isDragging }) =>
    isDragging ? "none" : "transform 0.5s ease-in-out"};
  padding-right: max(0px, calc((100vw - 17.25rem) / 2));
  padding-left: max(0px, calc((100vw - 17.25rem) / 2));
  padding-bottom: ${({ theme }) => theme.spacing(2)};
  gap: ${({ theme }) => theme.spacing(2)};
  will-change: transform;
  align-items: center;
  display: flex;
`;
